import React from "react";
import { Col, Row } from "react-bootstrap";

const TEAM = [
  {
    name: "PT Mentos Ekspress",
    position: "",
    description:
      "PT Mentos Ekspress merupakan Badan Hukum Perseroan Terbatas yang didirikan berdasarkan hukum negara Republik Indonesia, yang berlamat kantor di Sona Topas Tower Lt. 8, Jl. Jend. Sudirman Kav. 26, Kelurahan Karet, Kecamatan Setiabudi, Kota Adm. Jakarta Selatan, DKI Jakarta, 12920. PT Mentos Ekspress adalah pemegang saham mayoritas dengan kepemilikan saham sebanyak 2.800 (dua ribu delapan ratus) lembar saham dengan mewakili 70% (tujuh puluh persen) dari keseluruhan saham yang ditempatkan dan disetorkan penuh pada PT Pohon Dana Indonesia",
  },
  {
    name: "PT Cahayabaru Duta Pratama",
    position: "",
    description:
      "PT Cahayabaru Duta Pratama merupakan Badan hukum Perseroan Terbatas yang didirikan berdasarkan hukum Republik Indonesia, yang beralamat di Ruko Grand Boulevard Blok E01 No.138, Kec. Panongan, Kab. Tangerang, Prov. Banten. PT Cahayabaru Duta Pratama adalah pemegang saham dengan kepemilikan saham sebanyak 1.200 (seribu dua ratus) lembar saham dengan mewakili 30% ( tiga puluh persen) dari keseluruhan saham yang ditempatkan dan disetorkan penuh pada PT Pohon Dana Indonesia.",
  },

];
function ShareHolder() {
  return (
    <React.Fragment>
      <div className="text-size-title-2 text-center fw-extra-bold text-secondary-dark mb-4 mb-lg-5">
        Pemegang Saham
      </div>
     
      <Row className="justify-content-center d-flex">
  {TEAM.map((t, idx) => {
    return (
      <Col md={6} sm={12} className="mt-4 d-flex" key={`team-${idx}`}>
        <div className="h-100 about-card d-flex flex-column">
          <div className="text-size-body-head fw-bold text-secondary-dark">
            {t.name}
          </div>
          <div className="text-size-sub-body-2 text-secondary mb-4">
            {t.position}
          </div>
          <div className="text-size-sub-body-2 text-primary flex-grow-1">
            {t.description}
          </div>
        </div>
      </Col>
    );
  })}
</Row>
    </React.Fragment>
  );
}

export default ShareHolder;
